import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-base-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  standalone: true,
  imports: [CommonModule, ToastModule, TranslateModule],
})
export class BaseToastComponent {
  constructor() {}
}
